/**
 * MongoDB Extended JSON formatını normal JavaScript değerlerine çeviren utility fonksiyonları
 */

/**
 * MongoDB $oid formatını string'e çevirir
 */
const parseOid = (value: any): string => {
  if (value && typeof value === 'object' && value.$oid) {
    return value.$oid;
  }
  return value;
};

/**
 * MongoDB $numberInt formatını number'a çevirir
 */
const parseNumberInt = (value: any): number => {
  if (value && typeof value === 'object' && value.$numberInt) {
    return parseInt(value.$numberInt, 10);
  }
  if (typeof value === 'string') {
    return parseInt(value, 10);
  }
  return value;
};

/**
 * MongoDB $numberLong formatını number'a çevirir
 */
const parseNumberLong = (value: any): number => {
  if (value && typeof value === 'object' && value.$numberLong) {
    return parseInt(value.$numberLong, 10);
  }
  if (typeof value === 'string') {
    return parseInt(value, 10);
  }
  return value;
};

/**
 * MongoDB $numberDouble formatını number'a çevirir
 */
const parseNumberDouble = (value: any): number => {
  if (value && typeof value === 'object' && value.$numberDouble) {
    return parseFloat(value.$numberDouble);
  }
  if (typeof value === 'string') {
    return parseFloat(value);
  }
  return value;
};

/**
 * MongoDB $date formatını Date objesine çevirir
 */
const parseDate = (value: any): Date => {
  if (value && typeof value === 'object' && value.$date) {
    if (value.$date.$numberLong) {
      return new Date(parseInt(value.$date.$numberLong, 10));
    }
    if (typeof value.$date === 'number' || typeof value.$date === 'string') {
      return new Date(value.$date);
    }
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'string') {
    return new Date(value);
  }
  return value;
};

/**
 * MongoDB Extended JSON formatını recursive olarak parse eder
 */
export const parseMongoDBExtendedJSON = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  // Array ise her elemanını parse et
  if (Array.isArray(obj)) {
    return obj.map(item => parseMongoDBExtendedJSON(item));
  }

  // Object ise recursive olarak parse et
  if (typeof obj === 'object') {
    // MongoDB $oid kontrolü
    if (obj.$oid) {
      return parseOid(obj);
    }

    // MongoDB $numberInt kontrolü
    if (obj.$numberInt !== undefined) {
      return parseNumberInt(obj);
    }

    // MongoDB $numberLong kontrolü
    if (obj.$numberLong !== undefined) {
      return parseNumberLong(obj);
    }

    // MongoDB $numberDouble kontrolü
    if (obj.$numberDouble !== undefined) {
      return parseNumberDouble(obj);
    }

    // MongoDB $date kontrolü
    if (obj.$date) {
      return parseDate(obj);
    }

    // Normal object ise tüm property'lerini parse et
    const parsed: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        parsed[key] = parseMongoDBExtendedJSON(obj[key]);
      }
    }
    return parsed;
  }

  // Primitive value ise olduğu gibi döndür
  return obj;
};

/**
 * Analytics verisini MongoDB formatından normal formata çevirir
 */
export const parseAnalyticsData = (mongoData: any) => {
  const parsed = parseMongoDBExtendedJSON(mongoData);
  
  // Eğer data içinde data objesi varsa, onu da parse et
  if (parsed.data) {
    return {
      ...parsed,
      data: parseMongoDBExtendedJSON(parsed.data)
    };
  }
  
  return parsed;
};

